import { Grid, makeStyles, Typography } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { BarChart } from "../../../../components/charts/BarChart";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";
import { accCarbonRevernues, accEmissionReduction } from "../sample";
import { CarboonRevenueLabel, EmissionReductionLabel } from "./labels";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(3.5),
  },
}));

export const HighestCarbonReduction = ({ building, onClose }) => {
  const classes = useStyles();

  return (
    <Box>
      <Header
        title="Highest Carbon Emission Reduction Building"
        hideTenants
        building={building}
        onClose={onClose}
      />

      <InfoBox color="#E7FCDC">
        <Typography variant="h4">
          Carbon reduction & revenues of this building are high above portfolio
          avg.
        </Typography>
      </InfoBox>

      <Grid container spacing={4}>
        <Grid item xs={6}>
          <Typography className={classes.chartTitle}>
            Acc. Carbon Emission Reduction
          </Typography>
          <BarChart
            height={170}
            barSize={20}
            chartData={accEmissionReduction}
            showLabelList
            CustomLabelList={EmissionReductionLabel}
            hideYAxis
            unit="KgCo2"
          />
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.chartTitle}>
            Acc. Carbon Revenues
          </Typography>
          <BarChart
            height={170}
            top={20}
            barSize={20}
            chartData={accCarbonRevernues}
            showLabelList
            CustomLabelList={CarboonRevenueLabel}
            barColors={["#019275", "#97FF9F", "#27E7C1"]}
            hideYAxis
          />
        </Grid>
      </Grid>

      <GroupButton buttons={[{ text: "SHARE" }]} />
    </Box>
  );
};
